<div class="period-grid-header"
  portalResponsive>
  @if (period?.startDate) {
    <div class="period-navigation"
      [class.is-last-period-col]="isLastPeriodColumn"
      >
      @if (isBackToTodayShown || isForwardToTodayShown) {
        <button translate="shared.time.today"
          class="portal-button today-btn"
        (click)="gotoToday()"></button>
      }
      @if (isFirstPeriodColumn) {
        <fa-icon
          [icon]="['fas', 'caret-left']"
          class="btn-icon previous-button"
        (click)="previousPeriods()" />
      }
      @if (isLastPeriodColumn) {
        <fa-icon
          [icon]="['fas', 'caret-right']"
          class="btn-icon next-button"
        (click)="nextPeriods()" />
      }
    </div>
  }
  <div class="period-main-header portal-flex-center"
    [attr.periodId]="period?.id?.toString() ?? ''"
    [class.current-period]="isCurrentPeriod">
    @if (isPast) {
      <p class="past-period-flag"
        >(<span translate="shared.time.past"></span>)</p>
      }
      <p class="period-of"
      translate="shared.time.weekOf"></p>
      @if (period?.startDate) {
        <p class="period"
          >
          {{ period?.startDate | dateFormatPipe : langService.currentLang.dateFormats?.short }}
          <span class="period-to"
          translate="shared.time.to"></span>
          {{ period?.endDate | dateFormatPipe : langService.currentLang.dateFormats?.short : true }}
        </p>
      } @else {
        <div class="sk-line date-skeleton"></div>
      }
    </div>

  </div>

